import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// Create a theme instance.
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#72C500',
    },
    secondary: {
      main: '#1D1D1B',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;